

// Product details slider arrow 
jQuery(function ($) {

  const $gallery = $('.product_detail_div');
  const $slides = $gallery.find('.product__media-item');

  const $thumbs = $('.product_detail_div .thumbnail-list__item');

  let current = 0;

  function showSlide(index) {

    if (index < 0) index = $slides.length - 1;
    if (index >= $slides.length) index = 0;

    current = index;

    // Main image active
    $slides.removeClass('is-active');
    $slides.eq(current).addClass('is-active');

    $slides.eq(current)[0].scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest'
    });

    // Thumbnail active remove old
    $thumbs.find('button').removeAttr('aria-current');
    $thumbs.removeClass('is-active active');

    // Add new active
    $thumbs.eq(current).addClass('is-active active');
    $thumbs.eq(current).find('button').attr('aria-current', 'true');

    $('.slider-counter--current').text(current + 1);
  }

  // Thumbnail click
  $thumbs.on('click', function (e) {
    e.preventDefault();

    let index = $(this).index();

    showSlide(index);
  });

  // Next
  $('.slider-button--next').first().on('click', function (e) {
    e.preventDefault();
    showSlide(current + 1);
  });

  // Prev
  $('.slider-button--prev').first().on('click', function (e) {
    e.preventDefault();
    showSlide(current - 1);
  });

});

// for have one image in slider > arrow hide 

document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll("media-gallery");

  galleries.forEach(gallery => {
    const slides = gallery.querySelectorAll(".product__media-item");
    const arrows = gallery.querySelectorAll(".slider-button");

    if (slides.length <= 1) {
      arrows.forEach(btn => btn.style.display = "none");
    } else {
      arrows.forEach(btn => btn.style.display = "");
    }
  });
});



// window.addEventListener('load', function () {
// 	const wrapper = document.getElementById('marquee-wrapper');
// 	const item = wrapper.innerHTML;
// 	wrapper.innerHTML = item.repeat(3);
// 	const finalContent = wrapper.innerHTML;
// 	wrapper.innerHTML = finalContent + finalContent;
// 	wrapper.style.animation = "scroll-loop 150s linear infinite";
// });

window.addEventListener('load', function () {
	const wrapper = document.getElementById('marquee-wrapper');
	const item = wrapper.innerHTML;
	wrapper.innerHTML = item.repeat(3);
	const finalContent = wrapper.innerHTML;
	wrapper.innerHTML = finalContent + finalContent;
	wrapper.offsetHeight;
	wrapper.style.animation = "scroll-loop 100s linear infinite";
});

// Review section 
jQuery(document).ready(function ($) {

  $('.feature-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    draggable: true,
    centerMode: true,
    // touchMove: true,
    // swipe: true,
    centerPadding: '95px',
    speed: 600,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '80px',
          centerMode: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: '30px',
          centerMode: true
        }
      }
    ]
  });

  $('.review_slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,

    pauseOnHover: true,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    swipeToSlide: true,
    touchMove: true,

    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          centerPadding: '40px'
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          centerPadding: '30px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          autoplay: false,
          speed: 500,
          swipe: true,
          draggable: true,
          touchMove: true
        }
      }
    ]
  });

});




// jQuery(document).ready(function(){
// 	new WOW().init();
//   	jQuery(window).on("resize", function (e) {
//         checkScreenSize();
//     });
// 	jQuery('#partners_logo').owlCarousel({
// 	     margin:30,
// 	     loop:true,
// 		 slideSpeed : 300,
// 		paginationSpeed : 400,
// 		autoplay:true,
// 		nav:false,
// 		pagination:false,  dots: false,
// 		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
// 	    responsive:{
// 	        0:{
// 	            items:1
// 	        },
// 	        480:{
// 	            items:1
// 	        },
// 	        700:{
// 	            items:1
// 	        },
// 	        1000:{
// 	            items:4
// 	        },
// 	        1100:{
// 	            items:4
// 	        }
// 	    }
// 	}); 
	 
// });

document.addEventListener('DOMContentLoaded', function () {
  if (typeof $ !== 'undefined' && $('.hero-slider-wrapper').length) {

    $('.hero-slider-wrapper').slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 500,

      customPaging: function(slider, i) {
        return '<button>' + ('0' + (i + 1)).slice(-2) + '</button>';
      }

    });

  }
});




 /* =========================Header hover menu new JS========================= */
document.addEventListener("DOMContentLoaded", function () {

  // only desktop
  if (window.innerWidth > 992) {

    const menuItems = document.querySelectorAll('.header__inline-menu details');

    menuItems.forEach((item) => {

      item.addEventListener('mouseenter', function () {
        this.setAttribute('open', '');
      });

      item.addEventListener('mouseleave', function () {
        this.removeAttribute('open');
      });
    });
  }
});